import { h, createContext } from 'preact';
import { useContext } from 'preact/hooks';
const ControllerContext = createContext(null);
export const ControllerProvider = ({ children, controller }) => {
    return h(ControllerContext.Provider, { value: controller }, children);
};
export const useController = () => useContext(ControllerContext);
export function withController(Component) {
    return ((props) => (
    // additional props must come after controller prop
    h(Component, { controller: useController(), ...props })));
}
